<div class="flex   flex-col relative text-center text-nowrap mx-[4%] font-semibold text-sm">
  <div
    *ngIf="!timeLap.isCurrentTime"
    class="flex flex-col"
  >
    <p class="text-green-800"> - </p>
    <img src="./assets/images/line.svg" alt="line" class="h-5" />
    <p class="text-green-800"> - </p>
  </div>
  <div
    *ngIf="timeLap.isCurrentTime"
    class="flex flex-col "
  >
    <p class="text-black">{{ timeLap.value }}%</p>
    <img src="./assets/images/Line 35.svg" alt="line" class="h-5" />
    <p class="text-black">{{ timeLap.extraValue }}%</p>
  </div>

  <p class="text-gray-400   self-center right-0 left-0 text-[0.6rem]   -bottom-3">{{ timeLap.name }}</p>
</div>
